import { TextFieldModule } from '@angular/cdk/text-field';
import {
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltip } from '@angular/material/tooltip';
import { ITemplate, ITemplateList, Identifier } from '../../../models/template.model';

@Component({
    standalone: true,
    selector: 'cva-template-listing',
    imports: [
        MatButtonModule,
        MatIconModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        TextFieldModule,
        MatTooltip
    ],
    styleUrl: './template-listing.component.scss',
    templateUrl: './template-listing.component.html'
})
export class TemplateListingComponent implements OnInit {
  templateListing: ITemplateList[];
  filteredTemplate: ITemplateList[];

  constructor(
    public matDialogRef: MatDialogRef<TemplateListingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      defaultPreferredTemplate: Identifier,
      noteTemplateListing: ITemplateList[]
    },
  ) {
    this.templateListing = this.data.noteTemplateListing;
  }

  ngOnInit(): void {
    this.filteredTemplate = JSON.parse(JSON.stringify(this.templateListing));
  }

  filterTemplate(query: string): void {
    // Reset the filter
    if (!query) {
      this.filteredTemplate = this.templateListing;
      return;
    }

    this.filteredTemplate = this.templateListing.map(template => {
      const filteredItems = template.items.filter(item =>
        item.name.toLowerCase().includes(query.toLowerCase())
      );

      return {
        ...template,
        items: filteredItems
      };
    }).filter(template => template.items.length > 0);
  }

  trackTemplateByFn(item: ITemplate) {
    return item.identifier;
  }

  trackByFn(item: ITemplateList) {
    return item.category;
  }

  onTemplateSelection(template: ITemplate) {
    this.matDialogRef.close(template.identifier);
  }
}
